import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const DepartmentViewModule = new Module({
  id: 'DEPARTMENT-OPERATION:VIEW:RESULT-TABLE',
  name: 'Department',
  path: 'department',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Department/View'))
  )
});

export const DepartmentAddModule = new Module({
  id: 'DEPARTMENT-OPERATION:CREATE:DEPARTMENT',
  name: 'add-department',
  path: 'department/add',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Department/Form/add'))
  )
});

export const DepartmentEditModule = new Module({
  id: 'DEPARTMENT-OPERATION:EDIT-DEPARTMENT',
  name: 'DepartmentEdit',
  path: 'department/edit',
  pathDef: 'department/edit/:id',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Department/Form/edit'))
  ),
  actions: {
    edit: {
      id: 'DEPARTMENT-OPERATION:EDIT-DEPARTMENT',
      name: 'edit-department-result-table',
      label: 'Edit'
    },
    delete: {
      id: 'DEPARTMENT-OPERATION:DELETE:RESULT-TABLE',
      name: 'delete-department-result-table',
      label: 'Delete'
    }
  }
});

const DepartmentModules = [
  DepartmentViewModule,
  DepartmentEditModule,
  DepartmentAddModule
];

export default new ModuleBundle('Department', DepartmentModules);
